import objectFitImages from 'object-fit-images';
const { scrollmagic } = require('./modules/scrollmagic');
const { pageTop } = require('./modules/pageTop');
const { smooth } = require('./modules/smooth');
const { toggleClass } = require('./modules/toggleClass');
const { acAction } = require('./modules/acAction');

scrollmagic();
pageTop();
smooth();
toggleClass();
acAction();
objectFitImages();
